import React, { useState } from "react";
import { Button, Container } from "reactstrap";
import { useNavigate } from "react-router-dom";
import formStyles from "../../../../assets/scss/common/formStyle.module.scss";
import styles from "./studydesign.module.scss";
import ReplicateHVDDesign from "../components/ReplicateHVDDesign";

type TabKey = "standard" | "replicate" | "parallel" | "latin";

const StudyDesignTabs: React.FC = () => {
  document.title = "Study Design | ZENTIXS VISTA";
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState<TabKey>("replicate");

  const tabs = [
    { key: "standard", label: "Standard Crossover (2x2)", icon: "ri-shuffle-line" },
    { key: "replicate", label: "Replicate (HVDs)", icon: "ri-file-copy-2-line" },
    { key: "parallel", label: "Parallel Design", icon: "ri-git-merge-line" },
    { key: "latin", label: "Latin Square (Multiple Trt)", icon: "ri-grid-line" },
  ];

  return (
    <React.Fragment>
      <div className={`page-content ${formStyles.pageContainer} ${styles.pageContent}`}>
        <Container fluid className="pt-0 mb-4">
          {/* Header */}
          <div className={styles.pageHeader}>
            <div className="d-flex align-items-center gap-3">
              <Button color="light" outline className="px-2 py-1 bg-white border" onClick={() => navigate(-1)}>
                <i className="ri-arrow-left-line text-dark"></i>
              </Button>
              <div>
                <h5 className={styles.sessionTitle}>
                  Advanced Sequence Configuration
                  <span className={`badge bg-light text-secondary border fw-normal ms-2 ${styles.sessionBadge}`}>
                    Draft
                  </span>
                </h5>
                <p className={styles.sessionSubtitle}>
                  Select the appropriate statistical design for your investigation protocol.
                </p>
              </div>
            </div>
            <div className="d-flex gap-3 align-items-center">
              <Button color="secondary" outline>Save Draft</Button>
              <Button color="primary">Finalize Design</Button>
            </div>
          </div>

          {/* Tabs & Content */}
          <div>
            <div className={`${styles.tabContainer} border-radius-10 mb-0`} style={{ borderRadius: '10px 10px 0 0' }}>
              {tabs.map((tab) => (
                <button
                  key={tab.key}
                  type="button"
                  className={`${styles.tabBtn} ${activeTab === tab.key ? styles.active : ""}`}
                  onClick={() => setActiveTab(tab.key as TabKey)}
                >
                  <i className={tab.icon}></i>
                  {tab.label}
                </button>
              ))}
            </div>

            {/* Content Area */}
            <div className={styles.tabContent}>
              <div className={styles.unifiedWrapper}>
                {activeTab === "replicate" ? (
                  <ReplicateHVDDesign />
                ) : (
                  <div className="text-center py-5">
                    <h5 className="text-muted">Content for {tabs.find(t => t.key === activeTab)?.label} coming soon.</h5>
                  </div>
                )}
              </div>
            </div>
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default StudyDesignTabs;
